import createLocationModel from './lib/create_location_model';

export default createLocationModel({
  modelName: 'ApiTokens',
  properties: {},

  statics: {
    breadcrumb: 'API Tokens',
  },
});
